import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { TreasureItem } from '../../types';
import { useReferenceDataStore } from '../../stores/referenceDataStore';
import { SpellCard } from '../shared/SpellCard';

interface UseScrollModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  item: TreasureItem;
  invokedSpellId: string;
}

export const UseScrollModal: React.FC<UseScrollModalProps> = ({
  open,
  onClose,
  onConfirm,
  item,
  invokedSpellId,
}) => {
  const getSpellById = useReferenceDataStore((s) => s.getSpellById);
  const spell = getSpellById(invokedSpellId);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} maxWidth="xs" fullWidth>
      <DialogTitle>Use {item.name}</DialogTitle>
      <DialogContent sx={{ display: 'flex', justifyContent: 'center', pt: 2 }}>
        {spell ? (
          <SpellCard spell={spell} showTargetNumber={false} />
        ) : (
          <Typography variant="body2">
            {item.description ?? 'No description available.'}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained">Use Scroll</Button>
      </DialogActions>
    </Dialog>
  );
};
